import React from "react";

const ResourcesLower = () => {
    return (
        <div className="lower-container">
            <h1>ResourcesLower</h1>
        </div>
    )
}

export default ResourcesLower